import cn from 'classnames'

import styles from './styles.module.scss'

import ChevronIcon from './icons/chevron.svg'

export const MoreButton = ({
  title,
  onClick,
  className,
  isIconRotated = false,
}: {
  title: string
  onClick?: () => void
  className?: string
  isIconRotated?: boolean
}) => {
  return (
    <button className={cn(styles.button, className)} onClick={onClick}>
      <span>{title}</span>
      <img src={ChevronIcon} className={cn(styles.button__icon, { [styles.rotated]: isIconRotated })} />
    </button>
  )
}
